import React, { useState, useRef, useContext, useEffect } from 'react'
import { CreateTag, Filter } from 'component'
import util from 'meinian-package/src/utils/util'
import qs from 'qs'
import { GENDER_VALUE } from 'meinian-package/src/component/enum'
import Intelligent from './intelligent'
import Tag from './tag'
import { SwitchPageTab } from '../../../components/switchTab'
import { AccountContext } from '../../../../context'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../../components/header/customizeHeader'
import styles from './index.module.less'

const industryList = {
  女装: [16],
  男装: [30],
  男童: [50008165],
  女童: [50008165],
  // '童装': [50008165],
  鞋靴: [50006843, 50011740, 50012029, 122650005],
}

export default () => {
  const options = [{ label: '智能标签', value: 1 }, { label: '款式标签', value: 2 }]
  const qsParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const { userInfo = {} } = useContext(AccountContext)
  const [tab, setTab] = useState(+qsParams.tab || 1)
  const tagRef = useRef(null)

  const [params, setParams] = useState({})
  const [genderList, setGenderList] = useState(['女装', '男装'])

  useEffect(() => {
    // 获取用户开通的行业列表
    const _genderList = []
    for (const i in industryList) {
      if (i !== '鞋靴') {
        userInfo?.rootCategoryIds?.includes(industryList[i][0]) && _genderList.push(i)
      } else {
        for (const v of industryList[i]) {
          if (userInfo?.rootCategoryIds?.includes(v)) {
            _genderList.push(i)
            break
          }
        }
      }
    }
    setGenderList(_genderList.length > 0 ? _genderList : ['男装', '女装'])
    const result = JSON.parse(localStorage.getItem('meinianIntelligentFilter') || '{}')
    setParams({
      gender: result?.gender || GENDER_VALUE.WOMEN,
      inspirationIdList: result?.inspirationIdList || [],
      userIdList: result?.userIdList || []
    })
  }, [])

  const onTab = (val, cur) => {
    util.track('mn-header-link', {
      module1: '侧边栏',
      module2: '分类标签',
      module3: cur.label,
    })
    setTab(val)
  }
  return <>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '智能分类',
          path: '/home/category-tags'
        }
        ]}
      />}
    />
    <div className={styles['mn-home-category-tags']}>
      <div className="header">
        <SwitchPageTab
          value={tab}
          options={options}
          onChange={onTab}
          renderRight={() => <div>
            {
            tab === 1 ? <>
              <Filter.Gender
                data={genderList.map(item => ({ label: item, value: item }))}
                value={params.gender}
                onChange={(val) => {
                  localStorage.setItem('meinianIntelligentFilter', JSON.stringify({ ...params, gender: val }))
                  setParams({ ...params, gender: val })
                }}
              />
              <Filter.Inspiration
                value={params.inspirationIdList}
                onChange={(val) => {
                  localStorage.setItem('meinianIntelligentFilter', JSON.stringify({ ...params, inspirationIdList: val }))
                  setParams({ ...params, inspirationIdList: val })
                }}
              />
              <Filter.User
                value={params.userIdList}
                onChange={(val) => {
                  localStorage.setItem('meinianIntelligentFilter', JSON.stringify({ ...params, userIdList: val }))
                  setParams({ ...params, userIdList: val })
                }}
              />
            </> : <CreateTag onChange={() => tagRef.current?.init()}><div className="create-tab-btn">新增标签</div></CreateTag>
          }

          </div>}
        />
      </div>

      {
        tab === 1 ? <Intelligent params={params} /> : <Tag ref={tagRef} />
    }
    </div>
  </>
}
